import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
  selector: "wireless-suppliers-item",
  templateUrl: "wireless-suppliers-item.html",
  styleUrls: ["../../shortcut-menu.scss", "wireless-suppliers-item.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class WirelessSuppliersItem {
  protected suppliers = input.required<string[]>();
  protected hasAerohive = computed(() => this.suppliers().includes("Aerohive"));
  protected hasAruba = computed(() => this.suppliers().includes("Aruba"));
}
